export default __webpack_public_path__ + "static/media/template_6.98b13200.png";